import { Box, Typography } from "@mui/material";
import { TEXT_TITLE_COLOR } from "../constants/colors";

interface Props {
    searchValue: string
}

const SearchNotFound = ({ searchValue }: Props) => {
    return (
        <Box mt={1} sx={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box sx={{ height: '400px', width: '100%', borderRadius: '16px', border: '2px solid #919EAB3D', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box>
                    <Box sx={{textAlign:'center'}}>
                        <Typography variant="h4" color={TEXT_TITLE_COLOR}>Data Not found</Typography>
                    </Box>
                    <Typography variant="body2">
                        Your search did not match any records in our database &nbsp;
                        <br/>
                        <strong>&quot;{searchValue}&quot;</strong>.
                        <br />"Please kindly check your search term again".
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}
export default SearchNotFound;